/*
  In a case, then buckets listing is restricted, some storage providers can return empty buckets list,
  but other can return exception
*/
export enum BucketsListingRestrictedPossibility {
  Maybe = 'maybe',
  Exactly = 'exactly'
}

export const BucketNameValidator = {
  S3: /^(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)(?!.*\.-)(?!.*-\.)([a-z0-9][a-z0-9.-]*[a-z0-9])$/,
  Google: /^(?!g[o0]+g)(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)([a-z0-9]([a-z0-9-_]{0,61}[a-z0-9])?)(\.[a-z0-9]([a-z0-9-_]{0,61}[a-z0-9])?)*$/,
  Azure: /^(?!.*--)[a-z0-9]+(-[a-z0-9]+)*$/,
  B2: /^(?!b2-)[a-zA-Z0-9]+[-a-zA-Z0-9]*$/,
  Wasabi: /^(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)(?!.*\.-)(?!.*-\.)([a-z0-9][a-z0-9.-]*[a-z0-9])$/
}
